import { render, staticRenderFns } from "./ProjectJobs.vue?vue&type=template&id=6b263d12&scoped=true"
import script from "./ProjectJobs.vue?vue&type=script&lang=js"
export * from "./ProjectJobs.vue?vue&type=script&lang=js"
import style0 from "./ProjectJobs.vue?vue&type=style&index=0&id=6b263d12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b263d12",
  null
  
)

export default component.exports